/**
 * ─────────────────────────────────────────────────────────────
 * 📌 CLUB INVENTORY ROUTER 定義
 *
 * 店鋪庫存管理系統路由定義
 *
 * 📐 命名風格：
 * - ROUTER 變數名稱：CLUB_INVENTORY_ROUTER
 * - path 生成函數：GET_*_PATH
 * - 模組名稱大寫加下底線
 *
 * ─────────────────────────────────────────────────────────────
 */

/** █ 店鋪庫存管理系統 **/
export const CLUB_INVENTORY_ROUTER = Object.freeze({
	BASE: `/club-inventory/`,
	/** ▌進貨管理 **/
	PURCHASE: {
		BASE: `/club-inventory/purchase/`,
		OVERVIEW: `/club-inventory/purchase/overview/`,
		ORDER: `/club-inventory/purchase/order/:purchaseReceiptID/`,
		GET_ORDER_PATH: purchaseReceiptID => `/club-inventory/purchase/order/${purchaseReceiptID}/`,
	},
	/** ▌庫存管理 **/
	STOCK: {
		BASE: `/club-inventory/stock/`,
		OVERVIEW: `/club-inventory/stock/overview/`,
		DETAIL: `/club-inventory/stock/detail/:productID/:variantID/`,
		GET_DETAIL_PATH: (productID, variantID) => `/club-inventory/stock/detail/${productID}/${variantID}/`,
	},
	/** ▌出貨單管理 **/
	SHIPMENT: {
		BASE: `/club-inventory/shipment/`,
		OVERVIEW: `/club-inventory/shipment/overview/`,
		DETAIL: `/club-inventory/shipment/detail/:shipmentID/`,
		GET_DETAIL_PATH: shipmentID => `/club-inventory/shipment/detail/${shipmentID}/`,
	},
});
